export default __webpack_public_path__ + "static/media/boba.5495cdde.png";